interface MinutesRegistered {
	readonly minutesRegistered?: number | null;
	readonly billableMinutesRegistered?: number | null;
}

export interface LoggedMinutes {
	loggedMinutes: number;
	billableMinutes: number;
}

/**
 * Totals a ticket's time registrations. The detail header and the Time tab both
 * read `ticketTimeRegistrations` through this, so their figures cannot drift.
 */
export function sumLoggedMinutes(registrations: ReadonlyArray<MinutesRegistered>): LoggedMinutes {
	return registrations.reduce<LoggedMinutes>(
		(totals, reg) => ({
			loggedMinutes: totals.loggedMinutes + (reg.minutesRegistered ?? 0),
			billableMinutes: totals.billableMinutes + (reg.billableMinutesRegistered ?? 0),
		}),
		{loggedMinutes: 0, billableMinutes: 0}
	);
}

/**
 * Minutes as hours, to at most two decimals with trailing zeros dropped — two
 * places keep quarter-hours exact. 90 → "1.5", 75 → "1.25", 120 → "2".
 */
export function formatHours(minutes: number): string {
	return Number((minutes / 60).toFixed(2)).toString();
}

/** {@link formatHours} with the unit, e.g. 90 → "1.5h". */
export function hoursLabel(minutes: number): string {
	return `${formatHours(minutes)}h`;
}
